import { ThemeProvider as MuiThemeProvider } from "@material-ui/core";
import React from "react";
import createTheme from "../../utils/theme";
export default function ThemeProvider({ children }) {
    const theme = createTheme();
    return React.createElement(MuiThemeProvider, { theme: theme }, children);
}
//# sourceMappingURL=index.js.map